import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentRole, isAuthenticated } from "../auth";

export default function ProtectedRoute({ children, allowedRoles = null }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles?.length) {
    const role = getCurrentRole();
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
